import React from "react";
import { Box, Typography, InputAdornment } from "@mui/material";
import { ThemeProvider, createTheme, styled } from "@mui/material/styles";
import { MuiTelInput } from "mui-tel-input";
import { useThemes } from "../Theme/theme";

function CustomPhoneInputBox({
  name,
  forceCallingCode,
  defaultCountry,
  disableFormatting,
  flagSize,
  placeholder,
  type,
  onChange,
  state,
  focusOnSelectCountry,
  value,
  required,
  icon,
  label,
  from,
  disable,
  inputRef,
}) {
  const { theme } = useThemes();

  const themess = createTheme({
    palette: {
      mode: from ? "light" : theme.palette.mode,
      primary: {
        main: "#75428C",
      },
      danger: {
        main: "#e55353",
      },
    },
  });
  if (name === "phone") {
    return (
      <ThemeProvider theme={from ? themess : theme}>
        <Box sx={{ width: "100%", marginBottom: "10px" }}>
          <MuiTelInput
            size="small"
            name={name}
            label={label}
            fullWidth
            error={state?.errorStatus?.phone == true ? true : false}
            InputLabelProps={{
              style: { color: from ? "black" : theme?.palette?.TmId?.id?.toString().includes("9") ? "white" : "black" },
            }}
            // disableFormatting={true}
            flagSize={flagSize}
            defaultCountry={defaultCountry}
            type={type}
            forceCallingCode={forceCallingCode}
            value={value}
            autoComplete="tel"
            disabled={disable}
            focusOnSelectCountry={focusOnSelectCountry}
            placeholder={placeholder}
            onChange={onChange}
            required={required}
            className={
              state?.errorStatus?.[name] === true
                ? "error_border"
                : "normal_border"
            }
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom", // Aligns the dropdown vertically at the bottom of the input
                horizontal: "left", // Aligns the dropdown horizontally to the left of the input
              },
              transformOrigin: {
                vertical: "top", // Aligns the top of the dropdown with the bottom of the input
                horizontal: "left", // Aligns the left of the dropdown with the left of the input
              },
              PaperProps: {
                className: "custom-scrollbar",
                sx: {
                  backgroundColor: "#f5f5f5", // Background color of the dropdown
                  borderRadius: "8px", // Rounded corners
                  boxShadow: "0 3px 6px rgba(0,0,0,0.1)", // Shadow effect
                  height: "250px",
                },
              },
              MenuListProps: {
                sx: {
                  padding: "0", // Remove padding
                  "& .MuiMenuItem-root": {
                    padding: "10px 20px", // Custom padding for each item
                    "&:hover": {
                      backgroundColor: "#e0e0e0", // Change background on hover
                    },
                  },
                },
              },
            }}
            sx={{
              ".MuiFormLabel-asterisk": {
                color: "danger.main",
                fontSize: "20px",
                fontWeight: "bold",
              },
              "& .MuiInputLabel-root": {
                marginLeft: 0,
              },
              "& .MuiInputLabel-shrink": {
                marginLeft: 0,
              },
              fontSize: "12px",
              width: "100%",
              "& .MuiInputBase-root": {
                background: from ? "#FFF" : theme?.palette?.TmId?.id?.toString().includes("9") ? "#1E1E1E" : "transparent",
                fontSize: "14px",
              },
              "& .MuiOutlinedInput-root": {
                "&:focus-within": {
                  backgroundColor: from ? "" : "#ffb74d !important",
                },
                "& fieldset": {
                  borderColor: "#979899",
                },
                "&:hover fieldset": {
                  borderColor: "primary.main",
                },
                "&.Mui-focused fieldset": {
                  borderWidth: "1px",
                },
              },
              "& input:-webkit-autofill": {
                "-webkit-box-shadow": from
                  ? "0 0 0 30px white inset !important"
                  : theme?.palette?.TmId.id.toString().includes("9")
                  ? "0 0 0 30px #1E1E1E inset !important"
                  : "0 0 0 30px white inset !important",
                "-webkit-text-fill-color": from
                  ? "#000 !important"
                  : theme?.palette?.TmId.id.toString().includes("9")
                  ? "#fff !important"
                  : "",
              },
            }}
            InputProps={{
              ...(icon && {
                startAdornment: (
                  <InputAdornment position="start" className="icon">
                    {icon}
                  </InputAdornment>
                ),
              }),
            }}
            inputProps={{
              style: { border: "none", fontSize: "12px" },
            }}
          />
          <span sx={{ fontSize: "12px", marginLeft: "10px" }}>
            <Typography
              sx={{
                marginTop: "5px",
                marginLeft: "10px",
                fontSize: "12px",
                color: "danger.main",
              }}
            >
              {state?.errorFields?.[name]}
            </Typography>
          </span>
        </Box>
      </ThemeProvider>
    );
  } else {
    return (
      <ThemeProvider theme={from ? themess : theme}>
        <Box sx={{ marginBottom: "0px" }}>
          <MuiTelInput
            id="MuiTelInput"
            size="small"
            name={name}
            disabled={disable}
            label={label}
            inputRef={inputRef}
            error={state?.errorStatus[name] == true ? true : false}
            // disableFormatting={true}
            flagSize={flagSize}
            defaultCountry={defaultCountry}
            type={type}
            forceCallingCode={forceCallingCode}
            value={value}
            focusOnSelectCountry={focusOnSelectCountry}
            required={required}
            // label={label}
            onChange={onChange}
            className={
              state?.errorStatus?.[name] === true
                ? "error_border"
                : "normal_border"
            }
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom", // Aligns the dropdown vertically at the bottom of the input
                horizontal: "left", // Aligns the dropdown horizontally to the left of the input
              },
              transformOrigin: {
                vertical: "top", // Aligns the top of the dropdown with the bottom of the input
                horizontal: "left", // Aligns the left of the dropdown with the left of the input
              },
              PaperProps: {
                className: "custom-scrollbar",
                sx: {
                  borderRadius: "8px", // Rounded corners
                  boxShadow: "0 3px 6px rgba(0,0,0,0.1)", // Shadow effect
                  height: `${
                    document
                      .getElementById("MuiTelInput")
                      ?.getBoundingClientRect().bottom - 60
                  }px`,
                },
              },
            }}
            sx={{
              width: "100%",
              ".css-a7llkt-MuiInputBase-root-MuiOutlinedInput-root": {
                border: "none",
              },
              ".MuiFormLabel-asterisk": {
                color: "danger.main",
                fontSize: "20px",
                fontWeight: "bold",
              },
              ".css-1o9s3wi-MuiInputBase-input-MuiOutlinedInput-input ": {
                height: ".5rem",
                color:
                  state?.errorStatus?.[name] === true
                    ? "#e55353"
                    : "current-color",
              },
              "& input:-webkit-autofill": {
                "-webkit-box-shadow": from
                  ? "0 0 0 30px white inset !important"
                  : theme?.palette?.TmId.id.toString().includes("9")
                  ? "0 0 0 30px #1E1E1E inset !important"
                  : "0 0 0 30px white inset !important",
                "-webkit-text-fill-color": from
                  ? "#000 !important"
                  : theme?.palette?.TmId.id.toString().includes("9")
                  ? "#fff !important"
                  : "",
              },
            }}
            inputProps={{
              style: { border: "none" },
            }}
          />
          {icon}
          <span sx={{ fontSize: "12px", marginLeft: "10px" }}>
            <Typography
              sx={{
                marginTop: "5px",
                marginLeft: "10px",
                fontSize: "12px",
                color: "#e55353",
              }}
            >
              {state?.errorFields[name]}
            </Typography>
          </span>
        </Box>
      </ThemeProvider>
    );
  }
}

export default CustomPhoneInputBox;
